export default __webpack_public_path__ + "static/carousel6-2da7e5687ee65b09462ca0018f75ff0a.png";